import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function BasicSelect() {
    const [age, setAge] = React.useState('');

    const handleChange = (event: SelectChangeEvent) => {
        setAge(event.target.value as string);
    };

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Etapas</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    label="Etapas"
                    onChange={handleChange}
                    size='small'
                >
                    <MenuItem value={10}>{ }</MenuItem>
                    <MenuItem value={10}>Definição do Plano Base</MenuItem>
                    <MenuItem value={20}>Aprovação de Plano Proposto</MenuItem>
                    <MenuItem value={25}>Solicitar Ajustes</MenuItem>
                    <MenuItem value={30}>Congelar Plano</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
}


/* 
    <MenuItem value={10}>Ajuste de Planejamento</MenuItem>
    <MenuItem value={20}>Aprovações solicitadas</MenuItem>
    <MenuItem value={25}>Ajustes Pendentes</MenuItem>
     */